import { Tabs } from "@base-ui/react/tabs";
import type React from "react";
import { forwardRef } from "react";
import { numberTagClass, tabClass, transparentTabClass } from "./styles.css";

export type SingleTabVariant = "default" | "transparent";

interface SingleTabProps
  extends Omit<React.HTMLAttributes<HTMLElement>, "value"> {
  counter?: number;
  icon?: React.ReactNode;
  isSelected?: boolean;
  variant?: SingleTabVariant;
  /** The value used to identify this tab within a TabGroup/Tabs.Root context. */
  value?: any;
}

export const SingleTab = forwardRef(function SingleTab(
  {
    icon,
    counter,
    isSelected,
    children,
    variant = "default",
    value,
    className,
    ...props
  }: SingleTabProps,
  ref: React.Ref<HTMLElement>,
) {
  const variantClass =
    variant === "transparent" ? transparentTabClass : tabClass;
  const combinedClassName = `${variantClass}${className ? ` ${className}` : ""}`;

  return (
    <Tabs.Tab
      ref={ref}
      value={value}
      className={combinedClassName}
      data-slot="tab"
      {...props}
    >
      {icon && <span data-slot="tab-icon">{icon}</span>}
      {children}
      {!Number.isNaN(Number(counter)) && (
        <span className={numberTagClass} data-slot="tab-counter">
          {counter}
        </span>
      )}
    </Tabs.Tab>
  );
});

SingleTab.displayName = "SingleTab";
